/* ------- CONTEXTS - SMAG ------- */

const VSmagLayout = () => import('@b2ag/previsionnel/src/layouts/VSmagLayout.vue')
const VSmagPrevisionnel = () => import('@b2ag/previsionnel/src/application/views/VSmagPrevisionnel.vue')

export const smagRoutes = [
  {
    path: '/forecast',
    name: 'previsionnel',
    component: VSmagLayout,
    children: [
      {
        path: ':previsionnelId',
        name: 'smag-previsionnel',
        meta: {
          private: true,
          storePathBeforeAuth: true,
        },
        component: VSmagPrevisionnel,
        beforeEnter: (to, _from, next) => {
          const { previsionnelId } = to.params
          const mongoObjectIdRegex = /^[0-9a-fA-F]{24}$/
          const isValidMongoObjectId = (id: string) => {
            return mongoObjectIdRegex.test(id)
          }
          if (!isValidMongoObjectId(previsionnelId)) next({ name: 'not-found' })
          next()
        },
        props(route) {
          const { previsionnelId } = route.params
          return { previsionnelId }
        },
      },
    ],
  },
]
